import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import PassengerDetails from './passengerdetails';
import PaymentSummary from './paymentsummary';
import PassengerBilling from './passengerbilling';
import PaymentProcessing from './paymentprocessing';
import Progressbar from '../shared/progressbar';
import Header from '../shared/header';
import Footer from '../shared/footer';
import { connect } from 'react-redux';
import { FetchBooking } from '../../actions/booking';
import { FetchProducts } from '../../actions/product';
import { AddToBasket } from '../../actions/analytics';
import { ISOCurrencyCovert } from '../../helpers/locationHelper';
import Bundles from '../shared/bundles/bundles';
import { FetchUpgrades } from '../../actions/upgrades';

class Payment extends PureComponent {

  constructor(props){
    super(props)
    this.state = {
      iscyoa:false
    }
  }

  componentDidMount(){
    window.scrollTo(0, 0);

    const { match: {params:{ bookingguid, cyoa } }, history, FetchBooking, bookingGroup, FetchProducts, FetchUpgrades, products } = this.props;

    //Change document title
    document.title = "Book your adventure - Review your booking";

    //Load payment details with product details
    //Redirect if booking reference parameter not exist
    if(bookingguid === undefined || bookingguid === "0"){
     history.push('/');
    }else{
      //Fetch bookingGroup or API from API or load from state
      //Check if CYO tour or normal tours -
     if(Object.keys(bookingGroup).length === 0){

       FetchBooking(bookingguid, (cyoa === "cyoa") ? "builder_fetch" : '').then( (data) =>{

         if(data.trips.length !== 0) {

           if(products){
            const TOUR_IDS = data.trips.map(item => item.tour_id).join(",");
            FetchProducts(data.trips[0].iso_currency_code, TOUR_IDS);
           }

           if(data.trips.length < 2 && cyoa !== "cyoa") FetchUpgrades(data.trips[0].tour_id, data.trips[0].iso_currency_code, data.trips[0].departure_date);
         }
       });

       //Check if booking is CYOA
       this.setState({iscyoa:(cyoa === "cyoa") ? true : false});

     }
   }


  }

  componentDidCatch(error, info) {
    this.props.history.push('/');
  }


  componentDidUpdate(prevProps, prevState) {

    const { bookingGroup, history /*, match: {params:{ bookingguid } }*/ } = this.props;

    if(bookingGroup !== prevProps.bookingGroup){

      /*
      //check payments exist - redirect to confirmation
      if(bookingGroup.payments.length !== 0){
        console.log('payment exist');
        // history.push('/confirmation/' + bookingguid)
      }
    */

      //check booking valid
      if(bookingGroup.trips.length !== 0){
        //Add to basket tracking (criteo tracking & addToCart tracking)
        AddToBasket(bookingGroup);
      }else{
        history.push('/');
      }

    }

  }


  render() {
    const { bookingGroup, products, itineraries } = this.props;
    const _currency = (Object.keys(bookingGroup).length > 0 && bookingGroup.trips.length > 0 &&  bookingGroup.trips[0].length !== 0) ? bookingGroup.trips[0].iso_currency_code: "";
    const _tourId = (Object.keys(bookingGroup).length > 0 && bookingGroup.trips.length > 0 &&  bookingGroup.trips[0].length !== 0) ? bookingGroup.trips[0].tour_id : "";
    const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : "";


    return (
      <React.Fragment>
        <Header />
        <Progressbar tourId={_tourId} />
        <div className="payment-details">
          <div className="row">
            <div className="column small-12 large-11 large-offset-0-5">
              <PaymentSummary bookingGroup={bookingGroup} currency={ISOCurrencyCovert(_currency)} product={products} itineraries={_itineraries} />
              { (Object.keys(bookingGroup).length > 0 ) && <Bundles iscyoa={this.state.iscyoa} type="payment" /> }
              <PassengerDetails />
              { process.env.REACT_APP_GBP_BILLING_DISABLED === "false" && <PassengerBilling currency={_currency} /> }
              <PaymentProcessing />
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    )
  }
}

function mapStateToProps(state){
  return {
    bookingGroup:state.bookingGroup.data,
    currency:state.currency,
    products:state.products,
    itineraries:state.itineraries.data,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchBooking,
    FetchProducts,
    FetchUpgrades,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment);



// WEBPACK FOOTER //
// ./src/components/payment/payment.js